import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
import styles from "./style";
import { ReactComponent as Setting } from "../../../../assets/ViewLeave-images/setting.svg";
import CustomPagination from "../../../../components/CustomPagination";
import { useNavigate } from "react-router-dom";



const RolesAndPermissionsList = ({ data, page, setPage, total }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const rows = Array.isArray(data) ? data : [];

  const handleNavigate = (item) => {
    navigate("/dashboard/modifyRolePermission", { state: { item } })
  }
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead} >User Role</TableCell>
              <TableCell colSpan={5} ></TableCell>
              <TableCell sx={styles.TableHead}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((item, index) => {
                const isDisabled = item?.isDeleted || !item?.isActive;
                const jobPositionRaw = item?.personalInfo?.jobPosition;
                const jobPosition = Array.isArray(jobPositionRaw)
                  ? jobPositionRaw?.[0]
                  : jobPositionRaw;
                const roleLabel = jobPosition || "Employee";
                const isAdminRole = String(roleLabel).toLowerCase() === "admin";
                return (<TableRow key={index} 
                //   sx={{
                //   opacity: item.status === "deleted" || item.status === "blocked" ? 0.5 : 1, // greyed look
                //   pointerEvents: item.status === "deleted" || item.status === "blocked" ? "none" : "auto", // block clicks
                // }}
                >
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={item?.personalInfo?.image} sx={{ mr: 2 }} />
                    <Box>
                      <Typography sx={styles.dataName}>{item?.personalInfo?.firstName} {item?.personalInfo?.surName}</Typography>
                      <Typography sx={styles.lightText}>{item?.personalInfo?.email}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}><Box sx={{
                    backgroundColor: `${isAdminRole ? "#28AA4A" : "#00ABF4"}`,
                    borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", color: "#fff", fontSize: "12px", px: "14px", py: "5px", width: "fit-content",
                    textTransform: "capitalize"
                  }}>{roleLabel}</Box></TableCell>
                  <TableCell colSpan={5} sx={{ borderBottom: 0 }}></TableCell>
                  <TableCell sx={styles.tabledata} onClick={() => handleNavigate(item)}>
                    <Box sx={styles.tableAvtardatas}>
                      <Box sx={{ display: "flex", mr: 0.5 }}><Setting /></Box>
                      <Box><Typography sx={styles.lightTexts}>Modify Roles & Permissions</Typography></Box>
                    </Box>
                  </TableCell>
                </TableRow>);
              })
            )}
          </TableBody>
        </Table>
        {rows.length > 0 &&
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={rows.length}
          />
        }
      </TableContainer>
    </>
  );
};
export default RolesAndPermissionsList;
